import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import Field from 'core/components/form/form.v2';
import { SubRiskCollapsibleSection } from './sub-risk-collapsible-section';
import useStyles from './sub-risk.styles';

const BusinessPropertyForm = ({ fieldName, disabled }) => {
  const classes = useStyles();

  return (
    <SubRiskCollapsibleSection
      type="secondary"
      content={<div className={classes.headerText}>Business property, business occupancy on the premise</div>}
      initialOpen={false}
    >
      <Grid container spacing={2}>
        <Field
          xs={12}
          id={`${fieldName}.businessPropertyLimit`}
          name={`${fieldName}.businessPropertyLimit`}
          type="numeric"
          format={{ thousandSeparator: true, prefix: '$' }}
          mode="dark"
          label="Amount of insurance"
          disabled={disabled}
        />
        <Field
          id={`${fieldName}.businessPropertyLimitDetails`}
          name={`${fieldName}.businessPropertyLimitDetails`}
          type="textarea"
          mode="dark"
          label="Description of premise (required)"
          xs={12}
          rows={3}
        />
      </Grid>
    </SubRiskCollapsibleSection>
  );
};

BusinessPropertyForm.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

BusinessPropertyForm.defaultProps = {
  disabled: false
};

export default observer(BusinessPropertyForm);
